import { Controller } from "@hotwired/stimulus"

// Shows/hides content based on a checkbox state.
// Usage:
//   <div data-controller="checkbox-reveal">
//     <input type="checkbox" data-action="change->checkbox-reveal#toggle">
//     <div data-checkbox-reveal-target="content">…</div>
//   </div>
export default class extends Controller {
  static targets = ["content"]

  toggle(event) {
    this.contentTargets.forEach((el) => el.classList.toggle("hidden", !event.target.checked))
  }
}
